// dataformats.js

const lib = {};

lib.numberFormat = (n) => {  // https://stackoverflow.com/a/2901298
	return (!!n ? Number(n.toString().replace(/[^-\d.]/g,"")) : 0);
};
lib.decimalFormat = (n) => {  // https://stackoverflow.com/a/2901298
	return lib.numberFormat(n).toFixed(2);
};
lib.commaFormat = (n) => {  // https://stackoverflow.com/a/2901298
	return lib.decimalFormat(n).replace(/\B(?=(\d{3})+(?![-\d]))/g, ",");
};
lib.dollarFormat = (n) => {
	n = n?.toString().replace(/[^-\d.]/g,"");
	return (!!Number(n) && Number(n)<0?"-":"") + "$" + lib.commaFormat(Math.abs(n));  // https://req.to/bR7Brl
};

lib.numericOnly = (v)=>{
	if (!v) {
		return null;
	}
	// Remove non-digits, non-decimal, and non-hyphens (neg):
	let _v = v?.replace(/[^\d+\.-]/g,"");
	if (!!_v && _v.indexOf("-",1)>-1) {  // Remove any hyphens which are nit the first character
		_v = "-"+_v.replace(/\-/g,"");
	}
	// Prevent multiple periods
	if (!!_v && _v.match(/\./g)?.length > 1) {
		let __v = _v.split(".");
		_v = __v.shift() + "." + __v.join("");
	}
	// Prevent more than two decimal digits
	if (!!_v.match(/\.\d{3,}/)) {
		let __v = _v.split(".");
		_v = __v.shift() + "." + __v.join("").substring(0,2);
	}
	// Prevent multiple leading zeros before decimal or before end, works if neg.
	if (!!_v.match(/^\-?0+(\d(\.?|$))/)) {
		_v = _v.replace(/^\-?0+(\d(\.?|$))/,"$1");
	}
	// If changed...
	if (_v!==v) {
		v = _v;
	}
	return v;
};

const lp = (d)=>{
	return d.toString().padStart(2,"0");
};

lib.sqlDateFormat = (d) => {
	d = new Date(d);
	if (isNaN(d)) {
		d = new Date();
	}
	const _d = `${d.getFullYear()}-${lp(d.getMonth()+1)}-${lp(d.getDate())}`;
	return _d;
};

lib.humanDateFormat = (d) => {
	d = new Date(d);
	if (isNaN(d)) {
		d = new Date();
	}
	const _d = `${lp(d.getMonth()+1)}/${lp(d.getDate())}/${d.getFullYear()}`;
	return _d;
};

lib.sqlDateTimeFormat = (d) => {
	d = new Date(d);
	if (isNaN(d)) {
		d = new Date();
	}
	const _d = `${d.getFullYear()}-${lp(d.getMonth()+1)}-${lp(d.getDate())} ${d.getHours()}:${lp(d.getMinutes())}:${lp(d.getSeconds())}`;
	return _d;
};

lib.longStringToDate = (dateStr)=>{
	if (!dateStr) {
		dateStr = (new Date()).toString();
	}
	if (typeof(dateStr)!=="string") {
		dateStr = dateStr.toString();
	}
	if (dateStr.toString().split(" ").length !== 9) {
		dateStr = (new Date()).toString();
	}
	const da = dateStr.toString().split(" ");
	const ma = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];
	return ([da[3],"-",(1+ma.indexOf(da[1].toLowerCase())).toString().padStart(2,"0"),"-",da[2],"T",da[4],"Z"].join(""));
};

lib.hash = (id)=>{
	const fixedId = (id||"").toString().padStart(2,"0");
	const prefix = Math.random().toString().substring(2,5);
	return btoa(`${prefix}.${fixedId}`).replace(/=/g,"");  // Remove trailing double equal-signs, it un-hashes correctly without them.
};

lib.unhash = (hash)=>{
	try {
		return (Number(atob(hash).split(".")[1]) || "");
	} catch (err) {
		return "";
	}
};

lib.parseAddressObj = (str)=>{
	try {
		const rgxObj = str.match(/(.+), ([\w\s]+), (\w{2}) (\d{5}), US.?$/);
		if (!rgxObj[1] || !rgxObj[2] || !rgxObj[3] || !rgxObj[4]) {
			// Missing any part of expected address parts - bail!
			return "";
		}
		return {
			address: rgxObj[1],
			city: rgxObj[2],
			state: rgxObj[3],
			zip: rgxObj[4],
		};
	} catch (err) {
		return "";
	}
};

lib.humanReadyCode = (one_time_code)=>{
	one_time_code = one_time_code.replace(/-/g,"").toUpperCase();
	const midPos = Math.round(one_time_code.length/2);
	return `${one_time_code.slice(0,midPos)}-${one_time_code.slice(midPos)}`;
};


lib._typeof = (v)=>{ return Object.prototype.toString.call(v).match(/\[object (\w+)\]/)[1].toLowerCase(); };  // All possible results: ["boolean","string","number","object","array","date","function","undefined","null"].

module.exports = lib;